import React, { useCallback, useEffect, useState } from "react";
import { ActionButton, EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { getInUseGraphicSet } from "../../../services/commonService";

const ActionButtons = ({ id, customerId, name, mutation, history, deleteDisabled = false, intl }) => {
  const [deleteGraphicSet] = useMutation(mutation);

  const [inUseGraphicSet, setInUseGraphicSet] = useState(null);


  const handleSetInUseGraphicSet = data => {
    setInUseGraphicSet(data.is_in_use)
}

  const handleGetInUseGraphicSet = useCallback(() => {
    getInUseGraphicSet({
        customer_id: customerId, graphicset_id: id,
    }, handleSetInUseGraphicSet)
  }, [])

  useEffect(() => {
    if (id) {
      
      handleGetInUseGraphicSet()


    }
      
  }, [id]);
  console.log("inUseGraphicSet", inUseGraphicSet);

  return (
    <Restricted permissions={[permissions.graphicset_manage]}>
      <EditAction url={`/graphicset/edit/${id}/customerId/${customerId}`} />
      <ActionButton icon="file-copy" url={`/graphicset/new/${id}/customerId/${customerId}`} />
      {!inUseGraphicSet && <DeleteActionWithModal
        disabled={inUseGraphicSet}
        disabledTooltipText={intl.formatMessage({ id: "app.graphicset.delete.hasEvents" })}
        actionButton
        urlOnSuccess="/asset/list"
        history={history}
        mutation={deleteGraphicSet}
        mutationVariables={{ graphicSetId: id, customerId }}
        elementNameInResult="deleteGraphicSet"
        elementToDelete={name}
      />}
    </Restricted>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
  /**
   * Indica que el botón está deshabilitado
   **/
  deleteDisabled: PropTypes.bool,
};

export default injectIntl(ActionButtons);
